module.exports = __webpack_public_path__ + "static/media/projects.1799f024.png";